'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = require('../utils/lib/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareIcon = function ShareIcon(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'span',
      { className: 'ec-share-icon__svg' },
      _react2.default.createElement(
        'svg',
        {
          focusable: 'false',
          xmlns: 'http://www.w3.org/2000/svg',
          width: '16',
          height: '16',
          viewBox: '0 0 32 32'
        },
        _react2.default.createElement('path', { d: 'M6.8 22.2c1.6 0 3-.7 4-1.8l9 4.8c-.1.4-.2.8-.2 1.3 0 3 2.5 5.5 5.5 5.5s5.5-2.4 5.5-5.5-2.5-5.5-5.5-5.5c-1.6 0-3 .7-4 1.8l-9.5-5.2-.1-2.8 9.7-5.5c1 1 2.3 1.5 3.8 1.5 3 0 5.5-2.5 5.5-5.5S28.2 0 25.2 0s-5.5 2.4-5.5 5.5c0 .6.1 1.1.2 1.6l-9.3 5.7c-1-.9-2.3-1.5-3.8-1.5-3 0-5.5 2.4-5.5 5.5.1 2.9 2.5 5.4 5.5 5.4z' })
      )
    ),
    _react2.default.createElement(
      'span',
      { className: 'ec-share-cta-text' },
      children
    )
  );
};

ShareIcon.propTypes = {
  children: _PropTypes2.default.node.isRequired
};

var DefaultShareButton = function DefaultShareButton(_ref2) {
  var active = _ref2.active,
      ctaText = _ref2.ctaText,
      onButtonClick = _ref2.onButtonClick;
  return _react2.default.createElement(
    'button',
    {
      className: (0, _classnames2.default)({
        'ec-share-button': true,
        'ec-share-button__share': true,
        'ec-share-button__share--open': active
      }),
      onClick: onButtonClick
    },
    _react2.default.createElement(
      ShareIcon,
      null,
      ctaText
    )
  );
};

DefaultShareButton.defaultProps = {
  active: false
};

DefaultShareButton.propTypes = {
  active: _PropTypes2.default.bool,
  ctaText: _PropTypes2.default.string.isRequired,
  onButtonClick: _PropTypes2.default.func.isRequired
};

exports.default = DefaultShareButton;